































import Vue, { PropType } from 'vue';
import store from '@/store';

import { WebRequestStatus } from '@/models';
import { Outcome, Usage } from '@/models/packet';

import DeleteButtonWithMessage from '@/components/DeleteButtonWithMessage.vue';
import LoadingItem from '@/components/LoadingItem.vue';
import SinglePointGoalInput from '@/components/SinglePointGoalInput.vue';

export default Vue.extend({
  components: {
    DeleteButtonWithMessage,
    LoadingItem,
    SinglePointGoalInput
  },

  props: {
    outcome: {
      type: Object as PropType<Outcome>,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    objectiveName: {
      type: String,
      required: true
    }
  },

  computed: {
    usage(): Usage {
      return store.state.usage.usage;
    },

    canDelete(): boolean {
      return this.usage.userCount === 0;
    },

    deleteStatus(): WebRequestStatus {
      return store.state.usage.status;
    },

    allowHide(): boolean {
      return this.outcome.outcomeId > 0;
    }
  },

  methods: {
    save(fields: { value: string; color: string }) {
      this.$emit('save', fields);
    },

    close() {
      this.$emit('close');
    },

    deleteOutcome() {
      this.$emit('delete', this.outcome);
    },

    show() {
      this.$emit('show');
    },

    hide() {
      this.$emit('hide');
    }
  }
});
